import { FC, PropsWithChildren, ReactElement } from 'react';

import { ProductCategoryRenderer } from '../../../containers';
import { useTypedSelector } from '../../../redux/store';

interface ConnectedProductCategoryRendererProps extends PropsWithChildren {
    className?: string;
}

export const ConnectedProductCategoryRenderer: FC<ConnectedProductCategoryRendererProps> = ({
    children,
    className = '',
}): ReactElement => {
    const isLoading = useTypedSelector(state => state.productCategorySlice.isLoading);
    const breadcrumbs = useTypedSelector(state => state.productCategorySlice.breadcrumbs);
    const activeProductCategory = useTypedSelector(state => state.productCategorySlice.activeProductCategory);
    const pageData = useTypedSelector(state => state.productCategorySlice.pageData);

    return (
        <ProductCategoryRenderer
            isLoading={isLoading}
            breadcrumbs={breadcrumbs}
            activeProductCategory={activeProductCategory}
            pageData={pageData}
            className={className}
        >
            {children}
        </ProductCategoryRenderer>
    );
};
